import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { useAppDispatch } from '../reduxhooks';
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import React, { SetStateAction } from 'react';
import { categoryMap } from 'common-ts/dist/models/CategoryList';
import { Link as RouterLink } from "react-router-dom";
import { fetchProductsList } from '../redux/ProductsListRedux';
import { resetCartState } from '../redux/CartRedux';
import { FareastButton } from './OverlayComponentButton';

const useStyles = makeStyles((theme: Theme) =>
createStyles({
  paymentContent: {
    height: '100%',
    padding: '0px 24px',
    marginTop: '-10px',
  },
  dialogPaper: {
    borderRadius: '12px',
    margin: '24px',
  },
  dialogActions: {
    justifyContent: 'center',
    padding: '8px 24px 24px 24px',
  },
}),
);

interface PageCheckoutProps {
  checkoutStep: string,
  setCheckoutStep: React.Dispatch<SetStateAction<string>>,
  rejectionMessage: string,
}

export default function PageCheckoutOrderRejected({ checkoutStep, setCheckoutStep, rejectionMessage }: PageCheckoutProps) {
  const dispatch = useAppDispatch();
  const classes = useStyles();

  // The stock that just failed is still cached in productsList — App.tsx only
  // fetches the catalog while its status is Idle, so nothing refreshes it on
  // navigation. Refetch as soon as the rejection appears, so the home page
  // shows up-to-date availability however the shopper leaves this screen
  // (button, navbar or browser back).
  React.useEffect(() => {
    dispatch(fetchProductsList({}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // The server's rejection reason is English ("... is out of stock") while the
  // rest of the storefront is Indonesian, so we classify it here and never show
  // the raw string to the shopper.
  const isOutOfStock = /out of stock|kehabisan stok|stok/i.test(rejectionMessage);
  const title = isOutOfStock ? 'Stok Habis' : 'Pesanan Gagal';
  const body = isOutOfStock
    ? 'Maaf, stok produk sudah habis. Keranjang Anda telah dikosongkan.'
    : 'Pesanan gagal dibuat. Keranjang Anda telah dikosongkan. Silakan coba lagi.';

  return (
    <div className={classes.paymentContent}>
      {/* No onClose: the dialog is deliberately not dismissable by backdrop or
          escape, so the shopper has to take the button back to the home page. */}
      <Dialog open={true} classes={{ paper: classes.dialogPaper }}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <Typography>
            {body}
          </Typography>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <FareastButton
            component={RouterLink}
            to={categoryMap["HOME"]}
            buttonMarginTopBottom="0px"
            buttonMarginLeftRight="0px"
            onClick={() => {
              // Clears orderStatus back to 'unsubmitted' so re-entering checkout
              // later does not land straight back on this rejected step. The
              // catalog refetch already ran on mount.
              dispatch(resetCartState());
            }}
          >
            <b>KEMBALI KE BERANDA</b>
          </FareastButton>
        </DialogActions>
      </Dialog>
    </div>
  );
}
